import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TdLoadingService, TdDialogService, } from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { AnamnesisService, MasterService, LoginService, } from '../../../../../services/';

import { Anamnesis } from '../../../../../models';

@Component({
  selector: 'qs-anamnesisdetalle',
  styleUrls: ['./anamnesisdetalle.component.scss'],
  templateUrl: './anamnesisdetalle.component.html',
  viewProviders: [AnamnesisService, MasterService, ],
})

export class AnamnesisDetalleComponent implements AfterViewInit, OnDestroy {

  private mode: string;
  private title: string;

  private idPaciente: string;
  private visita: string;
  private colegiado: string;
  private accion: string;

  private anamnesis: Anamnesis;
  private oldAnamnesis: Anamnesis;

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _master: MasterService,
    private _anamnesisService: AnamnesisService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.colegiado = this._loginService.colegiado;
    this.visita = this._loginService.consulta.visita;
    this.anamnesis = new Anamnesis();
    this.oldAnamnesis = new Anamnesis();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      this.anamnesis = this._loginService.transient;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
    }
  }

  ngAfterViewInit(): void {
    this._changeDetectorRef.detectChanges();
  }

  delete(form: NgForm): void {
    this.mode = 'del';
    this.save(form);
  }

  save(form: NgForm): void {
    let fecha: Date = new Date();
    let message: string = '';
    let error: string = '';
    let messages: string[] = [
      'Anamnesis Añadida correctamente.', 'Error añadiendo Anamnesis.',
      'Anamnesis Actualizada correctamente.', 'Error actualizando Anamnesis.',
      'Anamnesis Borrada correctamente.', 'Error borrando Anamnesis', ];
    let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
    switch (this.mode) {
      case 'edit':
        this.accion = 'M';
        message = messages[2];
        error = message[3];
        break;
      case 'add':
        this.accion = 'I';
        message = messages[0];
        error = messages[1];
        break;
      case 'del':
        this.accion = 'B';
        message = messages[4];
        error = messages[5];
        break;
      default: break;
    }

    if (form.valid) {
      this._loadingService.register();
      let params: any = {
        iIdAnamnesis: this.accion !== 'I' ? this.anamnesis.idAnamnesis : '',
        iNumExpediente: this.idPaciente,
        iFecha: fecha,
        iNumVisita: this.visita,
        iDniMed: this._loginService.profesional.Dni,
        iLinea: 0,
        iTexto: this.anamnesis.texto,
        iHora: hora,
        iAccion: this.accion,
      };
      this._anamnesisService.guardarAnamnesis(params).subscribe((res: any) => {
        if (res) {
          this._loginService.anamnesis = res;
          this._loginService.mostrarMensaje(message, 'OK', 6000);
          this._loadingService.resolve();
          this._router.navigate(['/main/consulta/' + this.idPaciente + '/hojadeseguimiento', { outlets: { hojadeseguimiento: ['anamnesis'] } }]);
        } else {
          this._loginService.mostrarMensaje(message, 'OK', 6000);
          this._loadingService.resolve();
        }
      }, (resError: Error) => {
        this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
        this._loadingService.resolve();
      });
    }
  }

  /*
  canDeactivate(): Promise<boolean> | boolean {
    if ((this.oldAnamnesis.principioActivo == this.anamnesis.principioActivo) &&
      (this.oldAnamnesis.fecha.getDate() == this.anamnesis.fecha.getDate()) &&
      (this.oldAnamnesis.estado == this.anamnesis.estado) &&
      (this.oldAnamnesis.tipo == this.anamnesis.tipo)) {
      return true;
    } else {
      if (this.mode != 'save') {
        return new Promise((resolve) => {
          this._dialogService.openConfirm({
            message: 'Si pulsa aceptar, se perderán los datos introducidos.',
            title: '¿Desea abandonar el alta de anamnesis?',
            acceptButton: 'Aceptar',
            cancelButton: 'Cancelar'
          }).afterClosed().subscribe((accept: boolean) => {
            if (accept) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        });
      } else {
        return true;
      }
    }
  }*/

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/anamnesis/anamnesisdetalle/anamnesisdetalle.component.ts